import React from 'react'
import Skeleton from 'react-loading-skeleton'

function ImageReturnSkeleton() {
    return (
        <div className="image mb-sm-5 mb-4">
            <Skeleton width={`80em`} height={`50em`} />
        </div>
    )
}

export default ImageReturnSkeleton
